import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { TrendingTag } from '../../modals/recogntion.tags';
import * as TrendingTagsActions from './trending.tags.action';

export interface TrendingTagsState extends EntityState<TrendingTag> {
  hasNextPage?: boolean;
  errorMessage?: string;
  loading?: boolean;
}

export const trendingTagAdapter: EntityAdapter<TrendingTag> = createEntityAdapter<TrendingTag>({
  selectId: (trendingTag: TrendingTag) => trendingTag.identifier
});

const initialTrendingTagState = trendingTagAdapter.getInitialState({
  loading : true
});

const _trendingTagsReducer = createReducer(
  initialTrendingTagState,
  on(TrendingTagsActions.trendingTagsRequested, (state) => {
    return { ...state, hasNextPage: true, loading: true }
  }),
  on(TrendingTagsActions.trendingTagsLoaded, (state, { trendingTagList, hasNextPage }) => {
    return trendingTagAdapter.addMany(trendingTagList, { ...state, hasNextPage, loading: false });
  })
);

export function trendingTagsReducer(state: TrendingTagsState | undefined, action: any): TrendingTagsState {
  return _trendingTagsReducer(state, action);
}

export const {
  selectAll,
  selectEntities,
  selectIds,
  selectTotal
} = trendingTagAdapter.getSelectors();



